import React from 'react';
import cn from 'classnames';
import Button from '@components/Button';
import { ChevronLeftIcon, XIcon } from '@components/Icons';
import styles from './Header.module.scss';

interface PlainProps {
  onClose?: () => void;
  children?: React.ReactNode;
}

const Plain = ({ onClose, children = null }: PlainProps) => (
  <div className={styles.headerPlain}>
    {children}
    {onClose && (
      <Button className={styles.close} onClick={onClose}>
        <XIcon hoverOpacity />
      </Button>
    )}
  </div>
);

interface HeaderProps {
  prev?: () => void;
  children?: React.ReactNode;
  v2?: boolean;
  className?: string;
}

export default function Header({ prev, children, v2, className }: HeaderProps) {
  return (
    <div className={cn('modal-header', styles.header, v2 && styles.headerV2, className)}>
      {prev && (
        <Button className={styles.action} onClick={prev}>
          <ChevronLeftIcon />
        </Button>
      )}
      {children}
    </div>
  );
}

Header.Plain = Plain;
